export default {
  brand: {
    fileShare: 'ファイル共有'
  },
  common: {
    loading: '読み込み中...',
    confirm: '確認',
    cancel: 'キャンセル',
    download: 'ダウンロード',
    downloadAll: 'すべてダウンロード',
    downloadSelected: '選択項目をダウンロード',
    selectAll: 'すべて選択',
    deselectAll: '選択解除',
    rootDirectory: 'ルートディレクトリ',
    createTime: '作成日時',
    expireTime: '有効期限',
    totalSize: '合計サイズ',
    noFiles: 'ファイルがありません'
  },
  share: {
    expired: '共有ファイルの有効期限が切れました',
    invalidLink: '無効な共有リンク',
    needVerifyCode: '抽出コードを入力してください',
    verifyCodeLabel: 'コード',
    verifyCodePlaceholder: '抽出コードを入力',
    extractFiles: 'ファイルを抽出',
    extractionCodeError: '抽出コードが間違っています',
    uuidRequestFailed: 'ダウンロードリクエストに失敗しました',
    selectFilesFirst: '先にファイルを選択してください',
    unknownError: '不明なエラー'
  },
  error: {
    networkError: 'ネットワークエラー',
    connectionFailed: '共有デバイスに接続できません。デバイスが電源オフ、スリープ状態、またはサービスリージョンが変更された可能性があります。共有者にお問い合わせください。',
    outdatedLink: '共有デバイスに接続できません。古い共有リンクが使用された可能性があります。共有者にシステムをv2.0.10以上、APPをv2.1.5以上にアップグレードし、共有リンクを再コピーするようお願いしてください。',
    registryError: '公開ネットワーク穿透設定の取得エラー。Registryサービスに接続できません。',
    missingRegion: '共有リンクにサービスリージョン情報がありません。共有者にシステムをv2.0.10以上、APPをv2.1.5以上にアップグレードし、共有リンクを再コピーするようお願いしてください。'
  }
}
